export default __webpack_public_path__ + "static/media/tetra.9a205fa7.glb";